import React, { useMemo } from "react"
import { Button, Col, Flex, Row, Typography } from "antd"

import { LoadingBlock } from "@src/app/components/LoadingBlock"
import { notify } from "@src/app/components/notify"
import css from "./index.module.css"

type CheckOutCodeProps = {
  id: string
  isLoading: boolean
  paymentPageUrl: string
}
export const CheckOutCode = ({
  id,
  isLoading,
  paymentPageUrl,
}: CheckOutCodeProps) => {
  const code = useMemo(() => {
    return `
    <div>
        <a
          class="buy-with-crypto"
          href="${paymentPageUrl}/checkout/${id}"
          >
            Buy with Crypto
        </a>
        <script>
          (function (d) {
            var container = d.createElement("script");
            container.src =
              "${paymentPageUrl}/checkout/index.js?" +
              Math.random();
              d.body.appendChild(container);
          })(document);
        </script>
    </div>
`
  }, [paymentPageUrl, id])

  const copy = () => {
    navigator.clipboard.writeText(code)

    notify.success("Copied")
  }

  return (
    <Flex gap={"12px"} vertical>
      <Row align="middle" justify="space-between">
        <Col>
          <Typography.Title level={4}>Embed checkout</Typography.Title>
        </Col>
        <Col>
          <Button
            ghost
            id="GENERATED_ID_CHECKOUTCODE_BUTTON_COPY_CODE_1"
            loading={isLoading}
            onClick={copy}
            shape="round"
          >
            Copy code
          </Button>
        </Col>
      </Row>

      {isLoading ? (
        <LoadingBlock />
      ) : (
        <Row>
          <Typography.Text className={css.code}>{code}</Typography.Text>
        </Row>
      )}
    </Flex>
  )
}
